/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 5th 2021, 8:32:40 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OrganizationForm } from "organizations/components/OrganizationForm";
import { OrganizationBrandSettings } from "organizations/components/OrganizationBrandSettings";
import { useParams } from "react-router";
import { TabbedNavigator } from "ui-widgets";

export const OrganizationFormPage = ({ organizationId: organizationIdProp = null }) => {
  const { organizationId: organizationIdPathParam } = useParams();

  const organizationId = organizationIdPathParam ?? organizationIdProp;

  return (
    <>
      <div style={{ maxWidth: "100vw" }}>
        <TabbedNavigator>
          <>General Details</>
          <OrganizationForm organizationId={organizationId} />
          <>Organization Brand</>
          <OrganizationBrandSettings organizationId={organizationId} />
        </TabbedNavigator>
      </div>
    </>
  );
};
